/**
 * 503 — сервис на обслуживании. Включается флагом MAINTENANCE_MODE
 * (Caddy редиректит на /maintenance) или вручную.
 */
import { ErrorLayout, ErrorBlock } from '@/components/layout/ErrorLayout'
import { Button } from '@/components/ui/Button'

export function Maintenance() {
  return (
    <ErrorLayout hideBack>
      <ErrorBlock
        icon="construction"
        iconTone="warning"
        title="Делаем апгрейд 🔧"
        body={
          <>
            <p>Платформа на коротком техническом обслуживании.</p>
            <p className="mt-2 text-sm text-text-muted">
              Возвращаемся через 5–15 минут. Спасибо за терпение.
            </p>
          </>
        }
        actions={
          <Button variant="primary" onClick={() => window.location.reload()}>
            Проверить ещё раз
          </Button>
        }
      />
    </ErrorLayout>
  )
}
